<div id="divContainer">

  <button type="button" id="btnLoadList" (click)="GetDashboardLoad()" style="display:none">Load</button>
  <button type="button" id="btnFilterPanel" (click)="ShowFilterPanel()" style="display:none">Filter</button>
  <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>
  <button type="button" id="btnUploadExcel" (click)="ExcelUploadZinghr()" style="display:none">Add</button>
  <input type="file" #file id="FilePackage" placeholder="Choose file" (change)="UploadPackage(file.files)" style="display:none;">

  <div class="row">
    <div class="col-sm-12">
      <ul class="nav nav-tabs nav-tabs-custom" id="ulTabList">

        <li class="nav-item" id="liDashboardTab">
          <a class="nav-link active" data-toggle="tab" href="#tabDashboard" role="tab" title="View Dashboard" name="Dashboard" (click)="MainTabChange('Dashboard')">
            Dashboard
          </a>
        </li>
        <li class="nav-item" id="liPerfMartixTab">
          <a class="nav-link" data-toggle="tab" href="#tabPerfMartix" role="tab" title="View Perf. Martix" name="PerfMartix" (click)="MainTabChange('PerfMartix')">
            Perf. Martix
          </a>
        </li>
        <li class="nav-item" id="liKpiTab">
          <a class="nav-link" data-toggle="tab" href="#tabKPI" role="tab" title="View KPI" name="kpi" (click)="MainTabChange('KPI')">
            KPI
          </a>
        </li>

      </ul>
    </div>

    <div class="col-sm-2 divRight" style="display:none">
      <button class="btn btn-outline-info waves-effect waves-light" title="Filter Data" (click)="ShowFilterPanel()">
        <i class="fa fa-filter"></i>
      </button>
    </div>


  </div>

  <div class="tab-content">

    <div class="row col-12 divFilter" id="divFilter">

      <div class="col-sm-2">
        <div class="form-group1">
          <label for="ddlRange">Range</label>
          <select id="ddlRange" class="form-control" (change)="ChangeRange()">
            <!--<option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>-->
            <option value="Yearly">Yearly</option>
            <option value="Monthly">Monthly</option>
            <option value="Custom" selected="selected">Custom</option>
          </select>
        </div>
      </div>

      <div class="col-sm-2 divYear" name="FromYear">
        <div class="form-group1">
          <label for="ddlFromYear">From Year</label>
          <select id="ddlFromYear" class="form-control" (change)="onToYearChange($event)">
            <option value="0">Select Year</option>
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </div>
      </div>

      <div class="col-sm-2 divYear" name="ToYear">
        <div class="form-group1">
          <label for="ddlToYear">To Year</label>
          <select id="ddlToYear" class="form-control" (change)="onToYearChange($event)">
            <option value="0">Select Year</option>
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </div>
      </div>

      <div class="col-sm-2 divMonth" name="FromMonth">
        <div class="form-group1">
          <label for="ddlFromMonth">From Month</label>
          <select id="ddlFromMonth" class="form-control" (change)="onFromMonthChange($event)">
            <option value="0">Select Month</option>
            <option *ngFor="let month of months;" [value]="month.value">{{ month.name }}</option>
          </select>
        </div>
      </div>

      <div class="col-sm-2 divMonth" name="ToMonth">
        <div class="form-group1">
          <label for="ddlToMonth">To Month</label>
          <select id="ddlToMonth" class="form-control" (change)="onToMonthChange($event)">
            <option value="0">Select Month</option>
            <option *ngFor="let month of months;" [value]="month.value">{{ month.name }}</option>
          </select>
        </div>
      </div>


      <div class="col-sm-2 divDate" name="FromDate">
        <div class="form-group1">
          <label for="txtFromDt">From Date</label>
          <input type="date" class="form-control" id="txtFromDt">
        </div>
      </div>

      <div class="col-sm-2 divDate" name="ToDate">
        <div class="form-group1">
          <label for="txtToDt">To Date</label>
          <input type="date" class="form-control" id="txtToDt">
        </div>
      </div>


      <div class="col-sm-2">
        <div class="form-group1">
          <label for="ddlDepartment">Department</label>
          <select id="ddlDepartment" class="form-control" (change)="GetUserBUHead()">
            <option value=0>All</option>
            <option *ngFor="let item of departmentList" value={{item.Id}}>
              {{item.DepartmentName}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group1">
          <label for="ddlBUHead">BU Head</label>
          <select id="ddlBUHead" class="form-control" (change)="GetRoleList()">
            <option value=0>All</option>
            <option *ngFor="let item of buuserList" value={{item.UserId}}>
              {{item.LoginName}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group1">
          <label for="ddlRole">Role</label>
          <select id="ddlRole" class="form-control" (change)="GetUserList()">
            <option value=0>All</option>
            <option *ngFor="let item of roleList" value={{item.RoleID}}>
              {{item.RoleName}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group1">
          <label for="ddlUserList">User</label>
          <select id="ddlUserList" class="form-control">
            <option value=0>All</option>
            <option *ngFor="let item of userList" value={{item.UserId}}>
              {{item.LoginName}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-8">
        <br />
        <button type="button" id="btnLoad" class="btn btn-outline-info waves-effect waves-light"
                title="Get" (click)="GetDashboardLoad()">
          Search
        </button>
        &nbsp;
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Reset" (click)="ResetPanelFilter()">
          Reset
        </button>
      </div>

      <div class="col-sm-2" id="divGraphPagination">
        <div class="pagination-buttons">
          <button id="prevButton" title="Previous" (click)="PreviousPageData()" disabled><i class="fa fa-arrow-left"></i></button>
          <button id="nextButton" title="Next" (click)="NextPageData()"><i class="fa fa-arrow-right"></i></button>
        </div>
      </div>

    </div>

    <div id="tabDashboard" class="tab-pane active">
      <div class="divTableView">
        <table #dataTable class="display" style="width:100%"></table>
      </div>
    </div>

    <div id="tabPerfMartix" class="tab-pane">
      <div class="divTableView">
        <table #dataTablePM class="display" style="width:100%"></table>
      </div>
    </div>

    <div id="tabKPI" class="tab-pane " style="overflow: hidden; overflow-y: auto;">
      <div class="divTabMain">

        <div class="divPanelBox">
          <div class="col-sm-12" id="divEmpKpi">



            <highcharts-chart [Highcharts]="highchartsCol"
                              [options]="chartOptionsCol"
                              style="width: 100%; height: 400px; display: block;" class="divHighChart">
            </highcharts-chart>

          </div>
        </div>

        <div class="row" id="divMainThreshold">
          <div class="legend-container">
            <div class="legend-item">
              <div class="legend-color legend-poor"></div>
              <span id="spPoor"></span>
            </div>
            <div class="legend-item">
              <div class="legend-color legend-moderate"></div>
              <span id="spModerate"></span>
            </div>
            <div class="legend-item">
              <div class="legend-color legend-good"></div>
              <span id="spGood"></span>
            </div>
            <div class="legend-item">
              <div class="legend-color legend-excellent"></div>
              <span id="spExcellent"></span>
            </div>
          </div>
        </div>

        <div class="row col">
          <div class="col-sm-6">
            <app-emp-graph #empachieved></app-emp-graph>

            <div class="row divProductivtyRangePanel">
              <div class="legend-container">
                <div class="legend-item">
                  <div class="legend-color legend-poor"></div>
                  <span id="spProductivtyPoor"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-moderate"></div>
                  <span id="spProductivtyModerate"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-good"></div>
                  <span id="spProductivtyGood"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-excellent"></div>
                  <span id="spProductivtyExcellent"></span>
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-6">
            <app-emp-graph #empoccupancy></app-emp-graph>

            <div class="row divOccupancyRangePanel">
              <div class="legend-container">
                <div class="legend-item">
                  <div class="legend-color legend-poor"></div>
                  <span id="spOccupancyPoor"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-moderate"></div>
                  <span id="spOccupancyModerate"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-good"></div>
                  <span id="spOccupancyGood"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-excellent"></div>
                  <span id="spOccupancyExcellent"></span>
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-6">
            <app-emp-graph #emppunctuality></app-emp-graph>

            <div class="row divPunctualityRangePanel">
              <div class="legend-container">
                <div class="legend-item">
                  <div class="legend-color legend-poor"></div>
                  <span id="spPunctualityPoor"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-moderate"></div>
                  <span id="spPunctualityModerate"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-good"></div>
                  <span id="spPunctualityGood"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-excellent"></div>
                  <span id="spPunctualityExcellent"></span>
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-6">
            <app-emp-graph #empattendance></app-emp-graph>

            <div class="row divAttendanceRangePanel">
              <div class="legend-container">
                <div class="legend-item">
                  <div class="legend-color legend-poor"></div>
                  <span id="spAttendancePoor"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-moderate"></div>
                  <span id="spAttendanceModerate"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-good"></div>
                  <span id="spAttendanceGood"></span>
                </div>
                <div class="legend-item">
                  <div class="legend-color legend-excellent"></div>
                  <span id="spAttendanceExcellent"></span>
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-12">
            <app-emp-graph #empoverall></app-emp-graph>
          </div>
        </div>
        <br /><br /><br /> <br /><br /><br /> <br /><br /><br />
      </div>
    </div>


    <div class="control-sidebar control-sidebar panelBox" style="display: none;" id="divFilterPanel">
      <h5>Data Filter<i class="fas fa-times" (click)="HideFilterPanel()" title="Close"></i></h5>
      <hr />

    </div>

    <div class="modal" id="myModalTrans" [style.display]="showTransModal ? 'block' : 'none'">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" id="divTransCT">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title" id="divTransTitle"></h4>
            <button type="button" class="close" data-dismiss="modal" (click)="HideTransData()">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div>
              <ul class="nav nav-tabs nav-tabs-custom" id="ulPopupTabList">

                <li class="nav-item" id="liTransTab">
                  <a class="nav-link active" data-toggle="tab" href="#tabTrans" title="View Trans" name="Trans" (click)="PopupTabClick()">
                    Trans
                  </a>
                </li>

                <li class="nav-item" id="liDatewiseTab">
                  <a class="nav-link" data-toggle="tab" href="#tabDatewise" title="View Date wise" name="Datewise" (click)="PopupTabClick()">
                    Date wise
                  </a>
                </li>

              </ul>

              <div class="tab-content" id="divPopupTab">

                <div id="tabTrans" class="tab-pane active">
                  <div class="ProductivtyAchieved tbTrans">
                    <table #dataTableTrans class="display" style="width:100%"></table>
                  </div>
                  <div class="Punctuality tbTrans">
                    <table #dataTableTrans1 class="display " style="width:100%"></table>
                  </div>
                  <div class="Attendance tbTrans">
                    <table #dataTableTrans2 class="display Attendance" style="width:100%"></table>
                  </div>
                  <div class="Occupancy tbTrans">
                    <table #dataTableTrans3 class="display Occupancy" style="width:100%"></table>
                  </div>
                </div>

                <div id="tabDatewise" class="tab-pane">
                  <table #dataTableEmp class="display" style="width:100%"></table>
                  <div class="divThreshold">
                    <span class="lop">LOP</span> <span class="saturday">Saturday</span>
                    <span class="sunday ">Sunday</span><span class="leave">Leave</span>
                    <span class="holiday">Holiday</span>
                  </div>
                </div>

              </div>

              <div id="divPerfMatrixEmp" style="display:none">
                <table #dataTablePerfMatrixEmp class="display" style="width:100%"></table>
                <div class="divThreshold">
                  <span class="lop">LOP</span> <span class="saturday">Saturday</span>
                  <span class="sunday ">Sunday</span><span class="leave">Leave</span>
                  <span class="holiday">Holiday</span>
                </div>
              </div>

            </div>
          </div>
          <div id="LoadingImagePopup">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
          </div>
        </div>
      </div>
    </div>




  </div>

</div>
